import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { StickyNote } from "lucide-react";
import axios from "axios";
import Navbar from "./Navbar";

const PatientSummaryNote = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [summary, setSummary] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const fetchSummary = async () => {
    const patient_id = location.state?.patient_id;
    if (!patient_id) return;

    try {
      const response = await axios.post(
        "https://lovencare.gopillz.com/api/summary",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setSummary(response.data.summary || "No summary available for this patient.");
      }
    } catch (error) {
      console.error("Error fetching summary:", error);
      setSummary("Failed to fetch summary. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Main Container */}
      <div className="flex justify-center items-start px-4 sm:px-6 md:px-8 pt-28 pb-10">
        <div className="w-full max-w-3xl bg-white rounded-3xl shadow-2xl border border-blue-100 p-6 sm:p-10 transition-all">

          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="bg-blue-100 p-2 sm:p-3 rounded-full shadow-md">
              <StickyNote className="w-6 h-6 sm:w-8 sm:h-8 text-blue-600" />
            </div>
            <h1 className="text-xl sm:text-3xl font-semibold text-blue-700">
              Patient Summary Note
            </h1>
          </div>

          {/* Summary Content */}
          {isLoading ? (
            <div className="text-center text-blue-600 font-semibold text-lg">
              Loading summary...
            </div>
          ) : (
            <div className="relative bg-gradient-to-br from-white/80 to-blue-50/80 backdrop-blur-md text-gray-800 p-4 sm:p-6 rounded-2xl text-sm sm:text-lg leading-relaxed whitespace-pre-line border border-blue-300 shadow-md hover:shadow-lg transition-all duration-300">
              <div className="absolute -top-5 -left-5 bg-blue-500 text-white rounded-full p-2 shadow-lg hidden sm:block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-3-3v6m7 2a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h14z"
                  />
                </svg>
              </div>
              {summary}
            </div>
          )}

          {/* Back Button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-sky-600 hover:from-blue-600 hover:to-sky-700 text-white font-semibold px-6 py-3 rounded-full shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
            >
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientSummaryNote;
